import { GET_TIMESHEET_PROJECT_LIST_SUCCESS, GET_TIMESHEET_PROJECT_LIST_FAIL } from '../actionTypes';

const initialState = {
    projectList: null
};

const getTimesheetProjectListReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_TIMESHEET_PROJECT_LIST_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                projectList: action.payload.user,
            };
        case GET_TIMESHEET_PROJECT_LIST_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                projectList: null,
            };
        default:
            break;
    }

    return state;
};

export default getTimesheetProjectListReducer;



